import React, { useEffect, useState } from "react";
import { Button, Spin, Divider } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SectionHeader from "../../components/global/SectionHeader";
import moment from "moment";
import { Tooltip } from "antd";
import { useNavigate } from "react-router";
import { getProjectdetails } from "../../api/user/userapi";
import Layout from "../../components/global/layout";
import { BsArrowLeftSquare } from "react-icons/bs";
import ApiClient from "../../methods/api/apiClient";
import { notification } from "antd"; 


const ProjectDetails = (props) => {
  const [loading, setloading] = useState(false);
  const [names, setName] = useState();
  const [desc, setDescription] = useState();
  const [frontTech, setFrontTechnology] = useState();
  const [backTech, setBackTech] = useState();
  const [clientNames, setClientName] = useState();
  const [status, setStatus] = useState();
  const [type, setType] = useState();
  const [time, settime] = useState();
  const [dates, setDate] = useState();
  const [docs, setDocs] = useState();

  const [frontendclonelink, setfrontendclonelink] = useState();
  const [frontendclonepassword, setfrontendclonepassword] = useState();
  const [adminclonelink, setadminclonelink] = useState();
  const [adminclonepassword, setadminclonepassword] = useState();
  const [productionurl, setproductionurl] = useState();
  const [backendStagingWebsiteUrl, setbackendStagingWebsiteUrl] = useState();
  const [frontendStagingWebsiteUrl, setfrontendStagingWebsiteUrl] = useState();
  const [apiclonelink, setapiclonelink] = useState();
  const [apiclonepassword, setapiclonepassword] = useState();
  const [frontendownerid, setfrontendownerid] = useState();
  const [adminownerid, setadminownerid] = useState();
  const [apiownerid, setapiownerid] = useState();
  const [apibranch, setapibranch] = useState();
  const [adminbranch, setadminbranch] = useState();
  const [frontendbranch, setfrontendbranch] = useState();
  const [data, setData] = useState()
  const [projectData, setProjectData] = useState({});
  const [backendMembers, setBackendMembers] = useState([]);
  const [frontendMembers, setFrontendMembers] = useState([]);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const naviagte = useNavigate();

  const handleteam = () => {
    naviagte(`/projectassociation/list/${id}`);
  };
  const navigate = useNavigate();

  useEffect(() => {
    getProject();
    fetchData()
  }, []);


  const fetchData = () => {
    // setLoading(true);
    ApiClient.get(`project?id=${id}`)
      .then((res) => {
        if (res && res.data) {  
          setProjectData(res.data);
          setBackendMembers(res.data.backend_employees || []);
          setFrontendMembers(res.data.frontend_employees || []);
        } else {
          notification.error({ message: "No project team data found" });
        }
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        notification.error({ message: "Failed to fetch project data" });
        // setLoading(false);
      });
  };
  const [enddate, setenddate] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");

  const getProject = async (i) => {
    setloading(true);
    const Id = localStorage.getItem("courseid");
    try {
      const resp = await getProjectdetails(id);
      setloading(false);
      if (resp && resp.status === 200) {
        setData(resp.data.data)
        console.log(resp)
        const list = resp;
        console.log(list);

        setName(list.data.data.name);
        setDescription(list.data.data.description);
        setFrontTechnology(list.data.data.frontendtechnology);
        setBackTech(list.data.data.backendtechnology);
        setClientName(list.data.data.clientName);
        setStatus(list.data.data.progress_status);
        setType(list.data.data.project_type);
        setDate(list.data.data.startDate);
        setDocs(list.data.data.documents);
        settime(list.data.data.totaltime);
        setfrontendclonelink(list.data.data.frontend_clone_link);
        setfrontendclonepassword(list.data.data.frontend_clone_password);
        setadminclonelink(list.data.data.admin_clone_link);
        setadminclonepassword(list.data.data.admin_clone_password);
        setproductionurl(list.data.data.productionWebsiteUrl);
        setbackendStagingWebsiteUrl(list.data.data.backendStagingWebsiteUrl);
        setfrontendStagingWebsiteUrl(list.data.data.frontendStagingWebsiteUrl);
        setstagingurl(list.data.data.backendStagingWebsiteUrl);
        setapiclonelink(list.data.data.backend_clone_link);
        setapiclonepassword(list.data.data.backend_clone_password);
        setfrontendownerid(list.data.data.frontend_owner_workspace_id);
        setadminownerid(list.data.data.admin_owner_workspace_id);
        setapiownerid(list.data.data.api_owner_workspace_id);
        setadminbranch(list.data.data.updated_branch_admin);
        setfrontendbranch(list.data.data.updated_branch_frontend);
        setenddate(list.data.data.endDate);
        setapibranch(list.data.data.updated_branch_api);
      } else {
        setloading(false);
      }
      setloading(false);
    } catch (e) {
      setloading(false);
    }
  };
  const renderSubmitBack = () => {
    navigate("/allProject");
  };
  return (
    <Layout>
      <div className="">
        <div className="main-content">
          <div className="headings">
            <div className="d-flex align-items-center gap-3">
              <Tooltip title="Back Button">
                <p
                  onClick={renderSubmitBack}
                  className="pointer text-white  fs-3"
                >
                  <BsArrowLeftSquare />
                </p>
              </Tooltip>
              <SectionHeader title="Project Detail" />
            </div>
          </div>

          <div className="section ">
            <Spin spinning={loading}>
              <div className="">
                <div className=" ">
                  {/* <h3 className="text-center mb-3text-capitalize">
                    Project Name ({names})
                  </h3>
                  <div class="row mt-3"> */}
                  {/* <div class="col-md-4">
                  <label className="text-bold">Project-Name:</label>
                  <span > {names}</span>
                </div> */}
                  {/* <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Frontend-Technology:</label>
                        </div>
                        <div className="label_text">
                          <span> {frontTech}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Backend-Technology:</label>
                        </div>
                        <div className="label_text">
                          <span> {backTech}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Client-Name:</label>
                        </div>
                        <div className="label_text">
                          <span> {clientNames}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Total Time:</label>
                        </div>
                        <div className="label_text">
                          <span> {time}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Start-Date:</label>
                        </div>
                        <div className="label_text">
                          <span> {moment(dates).format("DD MMM YYYY")}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">End-Date:</label>
                        </div>
                        <div className="label_text">
                          <span> {moment(enddate).format("DD MMM YYYY")}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Project-Type:</label>
                        </div>
                        <div className="label_text">
                          <span> {type}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold ">
                            Frontend Owner Workspace Id:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className="">{data?.frontend_owner_workspace_id}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">
                            Admin Owner Workspace Id:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className="">{data?.admin_owner_workspace_id}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">
                            API Owner Workspace Id:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className="">{data?.api_owner_workspace_id}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Admin Updated Branch:</label>
                        </div>
                        <div className="label_text">
                          <span>{data?.updated_branch_admin}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">
                            Frontend Updated Branch:
                          </label>
                        </div>
                        <div className="label_text">
                          <span>{data?.updated_branch_frontend}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">API Updated Branch:</label>
                        </div>
                        <div className="label_text">
                          <span>{data?.updated_branch_frontend}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Frontend Clone Link:</label>
                        </div>
                        <div className="label_text">
                          <span className="">{frontendclonelink}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break pl-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold text-break">
                            Frontend App Password:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className="text-break ">
                            {frontendclonepassword}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Admin Clone Link:</label>
                        </div>
                        <div className="label_text">
                          <span className="">{adminclonelink}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break pl-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Admin App Password:</label>
                        </div>
                        <div className="label_text">
                          <span className="">{adminclonepassword}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold d-flex">
                            Production URL :
                          </label>
                        </div>
                        <div className="label_text">
                          <span className=" text-break">
                            {productionurl}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold d-flex">Frontend Staging URL :</label>
                        </div>
                        <div className="label_text">
                          <span className=" text-break">
                            {frontendStagingWebsiteUrl}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3 text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold d-flex">Backend Staging URL :</label>
                        </div>
                        <div className="label_text">
                          <span className=" text-break">
                            {backendStagingWebsiteUrl}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-3  text-break">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold d-flex">
                            API Clone Link:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className="  text-break">
                            {data?.backend_clone_link}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 mt-3 ">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold  text-break ">
                            API App Password:
                          </label>
                        </div>
                        <div className="label_text">
                          <span className=" text-break ">
                            {data?.backend_clone_password}
                          </span>
                        </div>
                      </div>

                    </div>
                    <div class="col-md-12 mt-3">
                      <div className="project_deatil">
                        <div className="label_heading">
                          <label className="text-bold">Description:</label>
                        </div>
                        <div className="label_text">
                          <span className="d-flex-inline">
                            {htmlToReactParser.parse(desc)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <h6 className="detail-header"> <Divider orientation="left">Project Details</Divider></h6>
                  <div className="row m-0">
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Project-Name<span>:</span></label> <span>{names}</span></li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Frontend-Technology<span>:</span></label> <span>{frontTech}</span></li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Backend-Technology<span>:</span></label> <span> {backTech}</span>                      </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Client-Name<span>:</span></label><span>  {clientNames}</span></li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Total Time<span>:</span></label> <span> {time} </span></li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Start-Date<span>:</span></label><span> {moment(dates).format("DD MMM YYYY")} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">End-Date<span>:</span></label> <span> {moment(enddate).format("DD MMM YYYY")} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Project-Type<span>:</span></label><span>  {type} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Frontend Owner Workspace Id<span>:</span></label><span>{data?.frontend_owner_workspace_id} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Admin Owner Workspace Id<span>:</span></label><span>{data?.admin_owner_workspace_id} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">API Owner Workspace Id<span>:</span></label><span>{data?.api_owner_workspace_id} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Admin Updated Branch<span>:</span></label> <span>{data?.updated_branch_admin}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">API Updated Branch<span>:</span></label><span> {data?.updated_branch_frontend} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0"> Frontend Updated Branch<span>:</span></label><span>{data?.updated_branch_frontend} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Frontend Clone Link<span>:</span></label> <span>{frontendclonelink}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0"> Frontend App Password<span>:</span></label> <span> {frontendclonepassword}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Admin Clone Link<span>:</span></label> <span>  {adminclonelink} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Admin app Password<span>:</span></label> <span>{adminclonepassword}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0"> Production URL<span>:</span></label> <span> {productionurl}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Frontend Staging URL<span>:</span></label> <span>  {frontendStagingWebsiteUrl} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Backend Staging URL<span>:</span></label> <span>  {backendStagingWebsiteUrl}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">API Clone Link<span>:</span></label><span>  {data?.backend_clone_link}</span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">API app Password<span>:</span></label> <span>{data?.backend_clone_password}</span>                     </li>
                    </div>
                    <div className="col-md-12">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Description<span>:</span></label> <span>    {htmlToReactParser.parse(desc)}</span>                     </li>
                    </div>
                  </div>
                  <h6 className="detail-header"> <Divider orientation="left">Team Details</Divider></h6>
                  <div className="row m-0">
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Project Manager<span>:</span></label> <span>  {projectData.project_manager &&
                          projectData.project_manager.fullName} </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">BDE Members<span>:</span></label> <span> 
                           {projectData.BDE && projectData.BDE.fullName}
                           </span>                     </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Frontend Developers<span>:</span></label>
                        {frontendMembers.map((member, index) => (
                          <span>
                            {index + 1}. {member.fullName} ({member.designation})
                          </span>
                        ))}
                      </li>
                    </div>
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Backend Developers<span>:</span></label>
                        {backendMembers.map((member, index) => (
                          <span>
                            {index + 1}. {member.fullName} ({member.designation})
                          </span>
                        ))}
                      </li>
                    </div>
                  </div>
                  {/* <Button
                    type="primary"
                    style={{ float: "right", marginTop: "10px" }}
                    className="pr-2"
                    onClick={() => handleteam()}
                  >
                    Team<i className="fa fa-arrow-right"></i>
                  </Button> */}
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div >
    </Layout >
  );
};

export default ProjectDetails;
